import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loginSuccess } from '../../slices/auth/login/reducer';

const OAuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    // Extract token and user data from URL parameters
    const urlParams = new URLSearchParams(location.search);
    const token = urlParams.get('token');
    const userDataString = urlParams.get('user');

    if (token && userDataString) {
      try {
        // Decode and parse user data
        const userData = JSON.parse(decodeURIComponent(userDataString));
        
        
        // Create auth user object with token
        const authUser = {
          token: token,
          ...userData
        };


        // Store in sessionStorage for the app to use
        sessionStorage.setItem('authUser', JSON.stringify(authUser));
        
        // Dispatch Redux action to store user in Redux state
        dispatch(loginSuccess(authUser));
        
        // Trigger custom event to notify other components of auth state change
        window.dispatchEvent(new Event('authUserUpdated'));
        

        // Back to whatever the visitor was reading, if anything sent them here.
        //
        // The path cannot ride along through OAuth: the backend appends
        // /auth/callback to the redirect it is given, so that value has to stay
        // an origin. Stashing it before leaving and reading it on the way back
        // is what carries it across the round trip.
        //
        // Same-origin paths only. This value survives a trip through Google and
        // back, and an absolute URL in it would turn sign-in into an open
        // redirect.
        const back = sessionStorage.getItem('postLoginRedirect');
        sessionStorage.removeItem('postLoginRedirect');
        const safe = back && back.startsWith('/') && !back.startsWith('//') ? back : null;
        navigate(safe || '/dashboard', { replace: true });
      } catch (error) {
        console.error('❌ Error processing OAuth callback:', error);
        // If there's an error parsing the data, redirect to login
        navigate('/login?error=oauth_data_error', { replace: true });
      }
    } else {
      // If no token or user data, just redirect to dashboard
      // This handles the normal "/" route behavior
      navigate('/dashboard', { replace: true });
    }
  }, [location.search, navigate]);

  // Show loading indicator while processing
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <div className="ms-3">
        <h5 className="mb-0">Completing sign in...</h5>
        <p className="text-muted mb-0">Please wait while we log you in.</p>
      </div>
    </div>
  );
};

export default OAuthCallback;
